export enum RecruitToHirePerson {
  Approvers = "Approvers",
  HiringManager = "Hiring Manager",
  Recruiter = "Recruiter",
  Interviewers = "Interviewers",
  Candidate = "Candidate",
  HRSpecialist = "HR Specialist"
}